<template>
    <div class='ReportHeaderCell' :style='cellStyleObj'>
        <div>{{ columnData.displayName }}</div>
        <div>
            <SortedAscIcon v-if='columnData.sort == "asc"' />
            <SortedDescIcon v-if='columnData.sort == "desc"' />
            <FunnelIcon v-if='filtersActive' />
        </div>
        <div class='dropdown' v-if='this.dropdownAvailable'>
            <div style='pointer:cursor' @click='toggleDropdown' v-if='!this.active'><DownChevronIcon /></div>
            <div style='pointer:cursor' @click='toggleDropdown' v-if='this.active'><UpChevronIcon /></div>
            <div class='dropdown-options' :class='{closed: !this.active}' :style='dropLeftPosition'>
                <div class='dropdown-option dropdown-option-grid ' @click='handleSortAsc' v-if='columnData.sortable'>
                    <div class='dropdown-option-label'>Sort Ascending</div>
                    <div class='dropdown-option-icon'><sortedAscIcon /></div>
                </div>
                <div class='dropdown-option dropdown-option-grid ' @click='handleSortDesc' v-if='columnData.sortable'>
                    <div class='dropdown-option-label'>Sort Descending</div>
                    <div class='dropdown-option-icon'><sortedDescIcon /></div>
                </div>
                <div class='dropdown-option dropdown-option-grid ' @click='toggleFacets' v-if='facetsAvailable'>
                    <div class='dropdown-option-label'>Filters</div>
                    <div class='dropdown-option-icon'><FilterIcon v-if='!facetsActive'/><CaretUpIcon v-if='facetsActive' /></div>
                </div>
                <div class='dropdown-option facet-dropdown' v-if='facetsActive'>
                    <div class='facet-row' v-for='facet in sortedFacets'>
                        <div>{{ facet.displayName}} [{{ facet.count }}]</div>
                        <div><input type='checkbox' :value='facet.value' :checked='facet.selected' @click='toggleSelectedFacet'/></div>
                    </div>
                </div>
                <div class='dropdown-option dropdown-option-grid' @click='toggleStats' v-if='statsAvailable'>
                    <div class='dropdown-option-label'>Metrics</div>
                    <div class='dropdown-option-icon'><CaretDownIcon v-if='!statsActive'/><CaretUpIcon v-if='statsActive' /></div>
                </div>
                <div class='dropdown-option stats-dropdown' v-if='statsActive'>
                    <div class='stats-row'>
                        <div>Min: </div>
                        <div>{{ formatStatValue(columnData.metrics.min) }}</div>
                    </div>
                    <div class='stats-row'>
                        <div>Max: </div>
                        <div>{{ formatStatValue(columnData.metrics.max) }}</div>
                    </div>
                    <div class='stats-row'>
                        <div>Avg: </div>
                        <div>{{ formatStatValue(columnData.metrics.mean) }}</div>
                    </div>
                    <div class='stats-row'>
                        <div>Has: </div>
                        <div>{{ formatStatValue(columnData.metrics.count, 'int') }}</div>
                    </div>
                    <div class='stats-row'>
                        <div>Blank: </div>
                        <div>{{ formatStatValue(columnData.metrics.missing, 'int') }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import DownChevronIcon from '../../icons/DownChevronIcon.vue';
    import SortedAscIcon from '../../icons/SortedAscIcon.vue';
    import SortedDescIcon from '../../icons/SortedDescIcon.vue';
    import FunnelIcon from '../../icons/FunnelIcon.vue';
    import FilterIcon from '../../icons/FilterIcon.vue';
    import CaretDownIcon from '../../icons/CaretDownIcon.vue';
    import UpChevronIcon from '../../icons/UpChevronIcon.vue';
    import CaretUpIcon from '../../icons/CaretUpIcon.vue';
    import Formatter from '../../../js/format.js';
    export default {
        name: 'ReportHeaderCell',
        components: {
            DownChevronIcon,
            SortedAscIcon,
            SortedDescIcon,
            FunnelIcon,
            FilterIcon,
            CaretDownIcon,
            UpChevronIcon,
            CaretUpIcon
        },
        props: ['columnData', 'isLast'],
        data(){ return{
            active: false,
            facetsActive: false,
            statsActive: false,
            dropLeftPosition: {
                left: this.$props.isLast ? "-171px" : "-100px"
            }
        }},
        computed: {
            cellStyleObj() { return {
                display: 'grid',
                gridTemplateColumns: '[name] 50% [sort] 25% [dropdown] 25%'
            }},
            facetsAvailable() {
                if(typeof this.columnData.facets === 'object' && this.columnData.facets !== null ){
                    if(Object.keys(this.columnData.facets).length > 0) return true;
                }
                return false;
            },
            statsAvailable(){
                if(typeof this.columnData.metrics === 'object' && this.columnData.metrics !== null){
                    if(Object.keys(this.columnData.metrics).length > 0) return true;
                }
                return false;
            },
            filtersActive(){
                return Object.values(this.columnData.facets).findIndex(facet => facet.selected) == -1 ? false : true;
            },
            dropdownAvailable(){
                if(this.columnData.sortable || this.columnData.facetsAvailable || this.columnData.statsAvailable) return true;
                else return false;
            },
            sortedFacets(){
                return Object.values(this.columnData.facets).sort((a,b) => b.count - a.count)
            }
        },
        methods: {
            toggleDropdown(){
                this.active = !this.active
            },
            handleSortAsc(e){
                this.$emit('update-sort', {column: this.columnData.name, direction: 'asc', append: e.shiftKey ? true : false })
                this.active = false;
            },
            handleSortDesc(e){
                this.$emit('update-sort', {column: this.columnData.name, direction: 'desc', append: e.shiftKey ? true : false })
                this.active = false;
            },
            toggleFacets(){
                this.facetsActive = !this.facetsActive
            },
            toggleStats(){
                this.statsActive = !this.statsActive
            },
            toggleSelectedFacet(e){
                this.$emit('update-selected-facet', {column: this.columnData.name, value: e.target.value, selected: e.target.checked })
            },
            formatStatValue(value, format = null){
                if(!format) format = this.columnData.dataType;
                return Formatter.format(value, format)
            }
        }
    }
</script>
